<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vertical-layout h-100",
      class: [_vm.layoutClasses],
      attrs: { "data-col": _vm.isNavMenuHidden ? "1-column" : null },
    },
    [
      _c(
        "b-navbar",
        {
          staticClass: "header-navbar navbar navbar-shadow align-items-center",
          class: [_vm.navbarTypeClass],
          attrs: { toggleable: false, variant: _vm.navbarBackgroundColor },
        },
        [
          _vm._t(
            "navbar",
            [
              _c("app-navbar-vertical-layout", {
                attrs: {
                  "toggle-vertical-menu-active": _vm.toggleVerticalMenuActive,
                },
              }),
            ],
            {
              toggleVerticalMenuActive: _vm.toggleVerticalMenuActive,
              navbarBackgroundColor: _vm.navbarBackgroundColor,
              navbarTypeClass: (_vm.navbarTypeClass ? (Array.isArray(_vm.navbarTypeClass) ? _vm.navbarTypeClass : [_vm.navbarTypeClass]) : []).concat([
                "header-navbar navbar navbar-shadow align-items-center",
              ]),
            }
          ),
        ],
        2
      ),
      !_vm.isNavMenuHidden
        ? _c("vertical-nav-menu", {
            attrs: {
              "is-vertical-menu-active": _vm.isVerticalMenuActive,
              "toggle-vertical-menu-active": _vm.toggleVerticalMenuActive,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function (slotProps) {
                    return [
                      _vm._t("vertical-menu-header", null, null, slotProps),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _c("div", {
        staticClass: "sidenav-overlay",
        class: _vm.overlayClasses,
        on: {
          click: function ($event) {
            _vm.isVerticalMenuActive = false
          },
        },
      }),
      _c(
        "transition",
        { attrs: { name: _vm.routerTransition, mode: "out-in" } },
        [
          _c(_vm.layoutContentRenderer, {
            key:
              _vm.layoutContentRenderer === "layout-content-renderer-left"
                ? _vm.$route.meta.navActiveLink || _vm.$route.name
                : null,
            tag: "component",
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.$scopedSlots, function (index, name) {
                  return {
                    key: name,
                    fn: function (data) {
                      return [_vm._t(name, null, null, data)]
                    },
                  }
                }),
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "footer footer-light", class: [_vm.footerTypeClass] },
        [_vm._t("footer", [_c("app-footer")])],
        2
      ),
      _vm._t("customizer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/layout-vertical/LayoutVertical.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as vue_composition_api from '@vue/composition-api';
import core_layouts_components_app_navbar_AppNavbarVerticalLayout_vue from '@core/layouts/components/app-navbar/AppNavbarVerticalLayout.vue';
import core_layouts_components_AppFooter_vue from '@core/layouts/components/AppFooter.vue';
import core_app_config_useAppConfig from '@core/app-config/useAppConfig';
import * as bootstrapvue from 'bootstrap-vue';
import core_layouts_components_layout_content_renderer_LayoutContentRendererDefault_vue from '@core/layouts/components/layout-content-renderer/LayoutContentRendererDefault.vue';
import core_layouts_components_layout_content_renderer_LayoutContentRendererLeft_vue from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeft.vue';
import core_layouts_components_layout_content_renderer_LayoutContentRendererLeftDetached_vue from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeftDetached.vue';
import components_vertical_nav_menu_VerticalNavMenu_vue from './components/vertical-nav-menu/VerticalNavMenu.vue';
import useVerticalLayout from './useVerticalLayout';
import mixinVerticalLayout from './mixinVerticalLayout';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












export default ({
  render,
  staticRenderFns,
  components: {
    // AppBreadcrumb,
    AppNavbarVerticalLayout: core_layouts_components_app_navbar_AppNavbarVerticalLayout_vue,
    AppFooter: core_layouts_components_AppFooter_vue,
    VerticalNavMenu: components_vertical_nav_menu_VerticalNavMenu_vue,
    BNavbar: bootstrapvue["BNavbar"],
    LayoutContentRendererLeftDetached: core_layouts_components_layout_content_renderer_LayoutContentRendererLeftDetached_vue,
    LayoutContentRendererLeft: core_layouts_components_layout_content_renderer_LayoutContentRendererLeft_vue,
    LayoutContentRendererDefault: core_layouts_components_layout_content_renderer_LayoutContentRendererDefault_vue
  },
  mixins: [mixinVerticalLayout],
  computed: {
    layoutContentRenderer() {
      const rendererType = this.$route.meta.contentRenderer;
      if (rendererType === 'sidebar-left') return 'layout-content-renderer-left';
      if (rendererType === 'sidebar-left-detached') return 'layout-content-renderer-left-detached';
      return 'layout-content-renderer-default';
    }
  },
  setup() {
    const {
      routerTransition,
      navbarBackgroundColor,
      navbarType,
      footerType,
      isNavMenuHidden
    } = core_app_config_useAppConfig();
    const {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      layoutClasses,
      overlayClasses,
      resizeHandler,
      navbarTypeClass,
      footerTypeClass
    } = useVerticalLayout(navbarType, footerType);

    // Resize handler
    resizeHandler();
    window.addEventListener('resize', resizeHandler);
    vue_composition_api.onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler);
    });
    return {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      overlayClasses,
      layoutClasses,
      navbarTypeClass,
      footerTypeClass,
      // App Config
      routerTransition,
      navbarBackgroundColor,
      isNavMenuHidden
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/layout-vertical/LayoutVertical.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
[dir] .bordered-layout .header-navbar {
  box-shadow: none;
}
[dir] .bordered-layout .header-navbar.floating-nav {
  border: 1px solid #ebe9f1;
}
[dir] .bordered-layout .header-navbar.fixed-top {
  border-bottom: 1px solid #ebe9f1;
  background: #efefef;
}
[dir] .bordered-layout .main-menu {
  box-shadow: none;
}
[dir=ltr] .bordered-layout .main-menu {
  border-right: 1px solid #ebe9f1;
}
[dir=rtl] .bordered-layout .main-menu {
  border-left: 1px solid #ebe9f1;
}
[dir] .bordered-layout .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a, [dir] .bordered-layout .main-menu.menu-light .navigation > li.sidebar-group-active > a {
  background: #ededed;
}
[dir] .bordered-layout .dropdown-menu {
  border: 1px solid #ebe9f1 !important;
  box-shadow: none;
}
[dir] .bordered-layout .main-menu .navigation, [dir] .bordered-layout .main-menu {
  background: #efefef;
}
[dir] .bordered-layout .card, [dir] .bordered-layout .bs-stepper:not(.wizard-modern):not(.checkout-tab-steps), [dir] .bordered-layout .bs-stepper.wizard-modern .bs-stepper-content {
  border: 1px solid #ebe9f1;
  box-shadow: none;
}
[dir] .bordered-layout .footer {
  box-shadow: none !important;
}
[dir] .bordered-layout .footer-fixed .footer {
  border-top: 1px solid #ebe9f1;
}
</style>
